module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3fIJM"))).then(() => parcelRequire('2KbAe'));